import Button from "atoms/buttons/button";
import ModalCloseButton from "atoms/buttons/modal-close-button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { CodeReferenceBlockHighlightRecord } from "models/view-models/code-reference-block-highlights/code-reference-block-highlight-record";
import ChecklistItemNoteRichTextEditor from "organisms/checklist-item-notes/checklist-item-note-rich-text-editor";
import { HighlightProperties } from "organisms/code-reference-block-editor/code-reference-preview";
import ColorSelect, {
    ColorSelectType,
} from "organisms/my-link/my-bookmarks/color-select";
import usePageLimits from "pages/notebooks/use-page-limits";
import React, { useEffect, useState } from "react";
import { HighlightColor } from "utilities/enumerations/highlight-color";
import { t } from "utilities/localization-utils";
interface CodeReferenceHighlightEditModalContentsProps {
    existingHighlight?: CodeReferenceBlockHighlightRecord;
    onClose: () => void;
    onSave: (partialHighlight: HighlightProperties) => void;
    onColorChange: (color: HighlightColor, id?: number) => void;
}

const CSS_BASE_CLASS = "highlight-modal";

const CodeReferenceHighlightEditModalContents = ({
    onClose,
    onSave,
    onColorChange,
    existingHighlight,
}: CodeReferenceHighlightEditModalContentsProps) => {
    const [noteText, setNoteText] = useState("");

    // This is necessary for updating the value in the select component.
    // The alternative is to pass the color down from the source.
    const [color, setColor] = useState<HighlightColor>(HighlightColor.Yellow);

    const { pageLimits } = usePageLimits();

    const MAX_CHARACTER_LIMIT =
        pageLimits?.codeReferenceBlockHighlightNoteLimit;

    const handleTextUpdate = (newValue: string, rawValue: string) => {
        setNoteText(newValue);
    };

    const handleSave = () => {
        onSave({
            highlightColor: color,
            note: noteText,
            id: existingHighlight?.id,
        });

        onClose();
    };

    const handleColorChange = (newColor: HighlightColor) => {
        // handles the value in the select component
        setColor(newColor);

        // updates the temporary highlight color
        onColorChange(newColor, existingHighlight?.id);
    };

    const handleCancel = () => {
        if (existingHighlight) {
            onColorChange(
                existingHighlight.highlightColor,
                existingHighlight?.id
            );
        }
        onClose();
    };

    useEffect(() => {
        if (existingHighlight) {
            setColor(existingHighlight.highlightColor);
            setNoteText(existingHighlight.note);
        }
    }, [existingHighlight]);
    return (
        <>
            <div className={`${CSS_BASE_CLASS}__header`}>
                <span>{t("highlight")}</span>
                <ModalCloseButton onClick={handleCancel} />
            </div>
            <div className={`${CSS_BASE_CLASS}__body`}>
                <ColorSelect
                    enumObject={HighlightColor}
                    onChange={handleColorChange}
                    type={ColorSelectType.Highlight}
                    value={color}
                />
                <ChecklistItemNoteRichTextEditor
                    maxLength={MAX_CHARACTER_LIMIT}
                    value={noteText}
                    onChange={handleTextUpdate}
                    displayImageOption={false}
                />
            </div>
            <div className={`${CSS_BASE_CLASS}__footer`}>
                <Button onClick={handleCancel} style={ButtonStyles.Tertiary}>
                    {t("cancel")}
                </Button>
                <Button onClick={handleSave}>{t("save")}</Button>
            </div>
        </>
    );
};

export default CodeReferenceHighlightEditModalContents;
